<template>
  <div class="change-password">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>修改密码</span>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" style="max-width: 500px; margin: 0 auto;">
        <el-form-item label="新密码" prop="newPassword">
          <el-input 
            v-model="form.newPassword" 
            type="password" 
            placeholder="请输入新密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input 
            v-model="form.confirmPassword" 
            type="password" 
            placeholder="请再次输入新密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { changeAdminPassword, getAdminId } from '@/utils/auth'

export default {
  name: 'ChangePassword',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        this.loading = true
        
        const adminId = getAdminId()
        if (!adminId) {
          this.$message.error('无法获取用户信息，请重新登录')
          this.$router.push('/login')
          return
        }
        
        const result = await changeAdminPassword(adminId, this.form.newPassword)
        
        if (result.success) {
          this.$message.success('密码修改成功，请重新登录')
          // 清除登录信息
          localStorage.removeItem('admin_token')
          localStorage.removeItem('isLoggedIn')
          // 跳转到登录页
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        } else {
          this.$message.error(result.message || '密码修改失败')
        }
      } catch (error) {
        if (error !== false) {
          this.$message.error('密码修改失败: ' + (error.message || '未知错误'))
        }
      } finally {
        this.loading = false
      }
    },
    handleReset() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.change-password {
  padding: 20px;
  min-height: calc(100vh - 40px);
}

.box-card {
  max-width: 600px;
  margin: 0 auto;
}
</style>

